import OperationsContextProvider from '../../context/OperationsContextProvider';
import OperationsMain from './components/OperationsMain';

function Operations() {
  return (
    <OperationsContextProvider>
      <OperationsMain />
    </OperationsContextProvider>
  );
}

export default Operations;
